/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPPREMIUMFREQUENCY } from './IAPPREMIUMFREQUENCY';
import {
    IAPPREMIUMFREQUENCYFromJSON,
    IAPPREMIUMFREQUENCYFromJSONTyped,
    IAPPREMIUMFREQUENCYToJSON,
} from './IAPPREMIUMFREQUENCY';

/**
 * 
 * @export
 * @interface ProposalSummaryRecurringContributions
 */
export interface ProposalSummaryRecurringContributions {
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryRecurringContributions
     */
    grossAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryRecurringContributions
     */
    netAmount?: number;
    /**
     * 
     * @type {IAPPREMIUMFREQUENCY}
     * @memberof ProposalSummaryRecurringContributions
     */
    frequency?: IAPPREMIUMFREQUENCY;
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryRecurringContributions
     */
    frequencyName: string;
    /**
     * 
     * @type {Date}
     * @memberof ProposalSummaryRecurringContributions
     */
    firstDebitOrderDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryRecurringContributions
     */
    annualGrowthRate?: number;
    /**
     * 
     * @type {Date}
     * @memberof ProposalSummaryRecurringContributions
     */
    growthDate?: Date;
}

/**
 * Check if a given object implements the ProposalSummaryRecurringContributions interface.
 */
export function instanceOfProposalSummaryRecurringContributions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "frequencyName" in value;

    return isInstance;
}

export function ProposalSummaryRecurringContributionsFromJSON(json: any): ProposalSummaryRecurringContributions {
    return ProposalSummaryRecurringContributionsFromJSONTyped(json, false);
}

export function ProposalSummaryRecurringContributionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryRecurringContributions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'grossAmount': !exists(json, 'GrossAmount') ? undefined : json['GrossAmount'],
        'netAmount': !exists(json, 'NetAmount') ? undefined : json['NetAmount'],
        'frequency': !exists(json, 'Frequency') ? undefined : IAPPREMIUMFREQUENCYFromJSON(json['Frequency']),
        'frequencyName': json['FrequencyName'],
        'firstDebitOrderDate': !exists(json, 'FirstDebitOrderDate') ? undefined : (new Date(json['FirstDebitOrderDate'])),
        'annualGrowthRate': !exists(json, 'AnnualGrowthRate') ? undefined : json['AnnualGrowthRate'],
        'growthDate': !exists(json, 'GrowthDate') ? undefined : (new Date(json['GrowthDate'])),
    };
}

export function ProposalSummaryRecurringContributionsToJSON(value?: ProposalSummaryRecurringContributions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'GrossAmount': value.grossAmount,
        'NetAmount': value.netAmount,
        'Frequency': IAPPREMIUMFREQUENCYToJSON(value.frequency),
        'FrequencyName': value.frequencyName,
        'FirstDebitOrderDate': value.firstDebitOrderDate === undefined ? undefined : (value.firstDebitOrderDate.toISOString()),
        'AnnualGrowthRate': value.annualGrowthRate,
        'GrowthDate': value.growthDate === undefined ? undefined : (value.growthDate.toISOString()),
    };
}

